import React, { Component } from "react";
import AntdTooltip, {TooltipProps} from 'antd/lib/tooltip';
import 'antd/lib/tooltip/style';

export default class Tooltip extends Component<TooltipProps> {
    render() {
        return (
          <AntdTooltip {...this.props} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/tooltip/index.tsx